import userConstants from '../user/constants';
import { constants as appConstants } from '../app';

/**
 * @type {Object} The initial state.
 */
export const initialState = {
  enabled: false,
  verified: false,
  skipped: false,
  // Set by the server when one of the user's customers requires a second factor.
  required: false,
  secret: null,
  url: null,
  source: null,
};

/**
 * @type {Object} constants used to modify the state.
 */
export const constants = {
  store: 'OTP/STORE',
  destroy: 'OTP/DESTROY',
  generate: 'OTP/GENERATE',
};

/**
 * A reducer to modify the state.
 *
 * @param {Object} state The current state.
 * @param {string} type The action type.
 * @returns {Object} The updated state.
 */
export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case constants.store:
      return {
        ...initialState,
        required: state.required,
        verified: true,
        enabled: true,
        skipped: false,
      };

    case constants.destroy:
      return {
        ...initialState,
        required: state.required,
        verified: false,
        enabled: false,
        skipped: true,
      };

    case constants.generate:
      return {
        ...state,
        secret: payload.secret,
        url: payload.url,
        source: payload.source,
      };

    case appConstants.setSessionExpired:
    case userConstants.logout:
      return initialState;

    case userConstants.login:
      return { ...initialState, ...payload.otp };

    default:
      return state;
  }
};
